import {TargetBlank} from '@wandb/weave/common/util/links';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {useState} from 'react';

import DocUrls from '../../../util/doc_urls';
import {capitalizeFirstLetter} from '../../../util/string';
import * as urls from '../../../util/urls';
import {BackLink} from '../../BackLink';
import {
  DEFAULT_REGISTRY_PROJECT_TYPES,
  globalRegistryType,
} from '../common/utils';
import {DeleteRegistryModal} from './DeleteRegistryModal';

type RegistrySettingsPageHeaderProps = {
  registry: globalRegistryType;
};

export const RegistrySettingsPageHeader = ({
  registry,
}: RegistrySettingsPageHeaderProps) => {
  const isDefaultRegistry = DEFAULT_REGISTRY_PROJECT_TYPES.includes(
    registry.registryName
  );
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  return (
    <Tailwind style={{width: '100%'}}>
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-col gap-2">
          <BackLink
            to={urls.globalRegistry(registry.orgName, registry.registryName)}
            text={capitalizeFirstLetter(registry.registryName)}
          />
          <div className="text-2xl font-semibold leading-8 text-moon-950">
            Registry settings
          </div>
        </div>
        <div className="inline-flex gap-8">
          <TargetBlank href={DocUrls.registry + 'configure_registry'}>
            <Button
              size="large"
              variant="secondary"
              className="flex items-center justify-center gap-8"
              icon="documentation">
              Documentation
            </Button>
          </TargetBlank>
          {!isDefaultRegistry && (
            <Button
              icon="delete"
              data-test="registry-delete-button"
              size="large"
              variant="ghost"
              onClick={() => setIsDeleteModalOpen(true)}
            />
          )}
        </div>
      </div>
      <DeleteRegistryModal
        isOpen={isDeleteModalOpen}
        registry={registry}
        setIsModalOpen={setIsDeleteModalOpen}
        handleModalClose={() => setIsDeleteModalOpen(false)}
      />
    </Tailwind>
  );
};
